<template>
  <div class="pGAddress">
    <div v-for="(item, j) in labels" :key="j" class="pGAItem pDivBorder">
      <div id="pFont">
        <PDiv>
          <PCH>
            {{ item.PatientName }}&nbsp;&nbsp;/&nbsp;&nbsp;{{ item.PatientId }}
          </PCH>
        </PDiv>
        <PDiv v-if="item.DocEnabled">
          <PCH> C/O:&nbsp;&nbsp;{{ item.DocName }} </PCH>
        </PDiv>
        <PDiv>
          <PCH>
            {{ item.Address }}
          </PCH>
        </PDiv>
        <PDiv>
          <PCH> Mobile:&ensp;{{ item.Mobile }} </PCH>
        </PDiv>
      </div>
    </div>
  </div>
</template>

<script>
import PDiv from "../../components/print/PDiv";
import PCH from "../../components/print/PContentHeading";
export default {
  components: {
    PCH,
    PDiv
  },
  props: {
    labels: {
      type: Array,
      default: () => {
        return [];
      }
    }
  }
};
</script>

<style scoped></style>
